/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import { CommonTable } from '../../../component/common/table2/CommonTable';
import Pagination from '../../../component/common/table2/Pagination';
import { pageOptions } from '../../../utils/dropDownConfig';
import Topbar from '../../PulseSurvey/Topbar';
import FormSelect from '../../../component/common/FormSelect';
import { FunnelIcon, PencilSquareIcon, InboxArrowDownIcon } from '@heroicons/react/24/outline';
import FilterModal from './FilterModal';
import {
  errorToast,
  formatAmount,
  formatAmountWithCurrency,
  getPaymentStatus,
  getPurchaseType,
  successToast,
  uploadImage
} from '../../../utils/helper';
import Loader from '../../../component/common/Loader';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import CommonPopover from '../../../component/common/popover';
// import ViewReasonPopup from "./ViewReasonPopup";
import FilterSummary from '../../../component/common/TableFilter/FilterSummary';
import filterIcon from '../../../assets/images/filter-icon.svg';
import { Api } from '../../../api';
import ApprovePaymentPopup from './ApprovePaymentPopup';
import SearchInput from '../../../component/common/Input/SearchInput';

/* NEW COMPONENTS */
import InvoiceStatCard from '../../../component/Peap/InvoiceCard';
import { Button } from '@headlessui/react';
import { Link } from 'react-router-dom';
import { B2BWellPointsPageData } from '../../../utils/pageContent';

const B2BWellPoints = () => {
  const theme = localStorage.getItem('selectedTheme');
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [wellpointStatisticsData, setWellpointStatisticsData] = useState([]);
  const [wellpointTransactionList, setWellpointTransactionList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [paidInvoicesCount, setPaidInvoicesCount] = useState(0);
  const [unpaidInvoicesCount, setUnpaidInvoicesCount] = useState(0);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [filterQuery, setFilterQuery] = useState('');
  const [filterCriteria, setFilterCriteria] = useState({});
  const [filterSummaryData, setFilterSummaryData] = useState({});
  const [manageRequestData, setManageRequestData] = useState({});
  const [openViewReasonPopup, setOpenViewReasonPopup] = useState(false);
  const [editingRowId, setEditingRowId] = useState(null);
  const [editingAmount, setEditingAmount] = useState({});
  const [originalAmounts, setOriginalAmounts] = useState({});
  const [isFilterApply, setIsFilterApply] = useState(false);
  const [openPaymentApproveModal, setOpenPaymentApproveModal] = useState(false);
  const [payload, setPayload] = useState({});
  const [isLoadingUpdate, setIsLoadingUpdate] = useState(false);
  const [searchText, setSearchText] = useState('');

  const inputRef = useRef({});

  /* NEW UI STATES */
  const [selectedTab, setSelectedTab] = useState('All');

  /* HANDLE PER PAGE */
  const handlePerPage = (_, value) => {
    setRecordsPerPage(Number(value));
    setCurrentPage(1);
  };

  /* HANDLE PAGINATION */
  const handlePagination = async (pageNumber, pageSize, query) => {
    setLoader(true);
    if (searchText !== '' && searchText !== undefined && searchText !== null) {
      query = `&email=${searchText}`;
    }

    if (selectedTab !== 'All') {
      if (selectedTab === 'Paid') {
        query = `&status=1`;
      }
      if (selectedTab === 'Pending') {
        query = `&status=2`;
      }
    }

    const response = await Api.getWellpointTransactionData(pageNumber, pageSize, query);

    if (response?.data?.meta?.code === 200) {
      setCurrentPage(pageNumber);
      setWellpointTransactionList(response?.data?.data);
      setTotalCount(response?.data?.meta?.total);
      setPaidInvoicesCount(response?.data?.meta?.paidInvoiceCount || 0);
      setUnpaidInvoicesCount(response?.data?.meta?.unpaidInvoiceCount || 0);
      // // Store original well_point values
      // let originalData = {};
      // response?.data?.data?.manageRequests.forEach(item => {
      //   originalData[item.id] = item.well_point;
      // });
      // setOriginalAmounts(originalData);

      setLoader(false);
    } else if (response?.code === 401) {
      setLoader(false);
      errorToast(response?.message);
    } else if (response?.data?.meta?.code === 0) {
      setCurrentPage(1);
      setWellpointTransactionList([]);
      setTotalCount(0);
      setLoader(false);
      errorToast(response?.data?.meta?.message);
    } else {
      setLoader(false);
    }
  };

  /* HANDLE FILTER */
  const handleFilter = () => {
    setShowFilterModal((state) => !state);
  };

  /* PAYMENT STATUS TO STRING */
  const mapPaymentStatusToString = (status) => {
    if (status === 1) return B2BWellPointsPageData.paymentStatusStrings.paid;
    if (status === 2) return B2BWellPointsPageData.paymentStatusStrings.unPaid;
    return ''; // Return empty if no status is found
  };

  /* PURCHASE TYPE TO STRING */
  const mapPurchaseTypeToString = (status) => {
    if (status === 1) return B2BWellPointsPageData.purchaseTypeStrings.instantPurchase;
    if (status === 2) return B2BWellPointsPageData.purchaseTypeStrings.invoice;
    return ''; // Return empty if no status is found
  };

  /* FILTER HANDLER */
  const filterHandler = useCallback(() => {
    let newData = { ...filterCriteria };

    // Initialize a filter summary object
    let summaryData = {};
    // Map each key to a human-readable value
    if (newData.type) {
      summaryData.type = mapPurchaseTypeToString(newData.type);
    }
    if (newData.status) {
      summaryData.status = mapPaymentStatusToString(newData.status);
    }
    if (newData.start_date) {
      summaryData.start_date = newData.start_date;
    }
    if (newData.end_date) {
      summaryData.end_date = newData.end_date;
    }
    // Add all filter criteria to summaryData
    setFilterSummaryData(summaryData);

    let tempFilterQuery = [];
    Object.keys(newData).forEach((key) => {
      const value = newData[key];
      if (value?.toString() || (value instanceof Date && !isNaN(value))) {
        tempFilterQuery.push(`&${key}=${value}`);
      }
    });
    console.log('ddtempFilterQuery', tempFilterQuery);
    const query = tempFilterQuery.join('');
    setFilterQuery(query);
    handlePagination(1, recordsPerPage, query);
  }, [filterCriteria, recordsPerPage]);

  /* REMOVE FILTER HANDLER */
  const removeFilterHandler = useCallback(
    (key) => {
      const newData = { ...filterCriteria };
      delete newData[key];
      setFilterCriteria(newData);

      let summaryData = {};
      // Map each key to a human-readable value
      if (newData.type) {
        summaryData.type = mapPurchaseTypeToString(newData.type);
      }
      if (newData.status) {
        summaryData.status = mapPaymentStatusToString(newData.status);
      }
      if (newData.start_date) {
        summaryData.start_date = newData.start_date;
      }
      if (newData.end_date) {
        summaryData.end_date = newData.end_date;
      }
      // Add all filter criteria to summaryData
      setFilterSummaryData(summaryData);

      let tempFilterQuery = [];
      Object.keys(newData).forEach(function (key) {
        const value = newData[key];
        if (value?.toString() || (value instanceof Date && !isNaN(value))) {
          tempFilterQuery.push(`&${key}=${value}`);
        }
      });
      let query = tempFilterQuery.join('');
      setFilterQuery(query);
      handlePagination(1, recordsPerPage, query);
    },
    [filterCriteria, recordsPerPage]
  );

  /* RESET HANDLER */
  const resetHandler = () => {
    setFilterCriteria({
      type: '',
      status: '',
      start_date: '',
      end_date: ''
    });
    setFilterSummaryData({
      type: '',
      status: '',
      start_date: '',
      end_date: ''
    });
    setFilterQuery('');
    setShowFilterModal(false);
    handlePagination(1, recordsPerPage, '');
  };

  /* USE EFFECT */
  useEffect(() => {
    handlePagination(currentPage, recordsPerPage, filterQuery);
  }, [currentPage, recordsPerPage, selectedTab]);

  /* FORMAT SHORT NUMBER */
  const formatShortNumber = (num) => {
    num = parseFloat(num?.toString().replace(/,/g, ''));
    if (isNaN(num)) return '-';
    const units = ['', 'K', 'M', 'B', 'T'];
    let unit = 0;
    while (num >= 1000 && unit < units.length - 1) {
      num /= 1000;
      unit++;
    }
    return `${+num.toFixed(1)}${units[unit]}`;
  };

  /* HANDLE VIEW SESSION */
  const handleViewReason = (rowData) => {
    setOpenViewReasonPopup(true);
    setManageRequestData(rowData);
  };

  /* HANDLE MARK PAYMENT AS PAID */
  const handleMarkPaymentAsPaid = async (rowId) => {
    const payload = {
      id: rowId,
      wellpointAmount: wellpointTransactionList.find((item) => item.id === rowId)
        ?.wellpoints_amount,
      status: 1
    };
    setPayload(payload);
    setOpenPaymentApproveModal(true);
  };

  /* HANDLE PAYMENT APPROVAL */
  const handlePaymentApprove = (payoutData) => {
    const reqBody = {
      ...payload,
      file: payoutData?.file?.type
    };
    console.log('reqBody', reqBody);
    setIsLoadingUpdate(true);
    Api.updateWellpointsHistory(reqBody)
      .then(async (response) => {
        if (response?.data?.meta?.code === 200) {
          const meta = response?.data?.meta;
          if (meta?.filename && meta?.uploadURL) {
            const uploadImageResponse = await uploadImage(
              payoutData?.file,
              meta?.uploadURL,
              meta?.filename
            );
            if (uploadImageResponse?.status === 200) {
              setIsLoadingUpdate(false);
              successToast(B2BWellPointsPageData.imageUploadedSuccessfullyMessage);
            }
          } else {
            setIsLoadingUpdate(false);
          }
          successToast(response?.data?.meta?.message);
          setOpenPaymentApproveModal(false);
          handlePagination(currentPage, recordsPerPage, filterQuery);
        } else {
          setIsLoadingUpdate(false);
          errorToast(response?.data?.meta?.message);
        }
      })
      .catch((error) => {
        setIsLoadingUpdate(false);
        errorToast(error);
      });
  };

  /* HANDLE STATUS UPDATE */
  const handleStatusUpdate = async (rowId, status) => {
    // setLoader(true);
    // try {
    //     const data = {
    //         manageRequestId: rowId,
    //         status,
    //     }
    //     const response = await CompanyApi.updateManageRequestStatus(data);
    //     if (response?.data?.meta?.code === 200) {
    //         setLoader(false);
    //         successToast(response?.data?.meta?.message);
    //         handlePagination(currentPage, recordsPerPage, filterQuery);
    //     } else {
    //         setLoader(false);
    //         errorToast(response?.data?.meta?.message);
    //     }
    // } catch (error) {
    //     setLoader(false);
    //     console.error('🚀 ~ update-manage-request-status ~ error:', error);
    // }
  };

  /* TABLE COLUMNS */
  const columns = useMemo(
    () => [
      {
        accessorKey: 'invoice_number',
        header: B2BWellPointsPageData.tableHeaderText.orderID,
        cell: ({ row }) => {
          return (
            <div className="text-left">
              <p className="text-sm font-medium text-black dark:text-white">
                {row?.original?.invoice_number === null
                  ? '-'
                  : `INV-${row?.original?.invoice_number}`}
              </p>
            </div>
          );
        }
      },
      {
        accessorKey: 'company_name',
        header: B2BWellPointsPageData.tableHeaderText.companyName,
        cell: ({ row }) => {
          return (
            <div className="text-left">
              <div className="text-[15px] leading-[18px] font-normal capitalize text-black dark:text-white">
                {row?.original?.user_id?.company_id?.company_name}
              </div>
            </div>
          );
        },
        enableSorting: false,
        enableHiding: false
      },
      {
        accessorKey: 'createdAt',
        header: B2BWellPointsPageData.tableHeaderText.dateReceived,
        cell: ({ row }) => (
          <div className="text-[15px] leading-[18px] font-normal whitespace-nowrap text-black dark:text-white">
            {moment(row.original.createdAt).format('DD MMM YYYY')}
          </div>
        )
      },
      {
        accessorKey: 'well_points',
        header: B2BWellPointsPageData.tableHeaderText.amount,
        cell: ({ row }) => (
          <div className="text-[15px] leading-[18px] font-normal text-black dark:text-white">
            {formatAmountWithCurrency(row.original.wellpoints_amount)}
          </div>
        )
      },
      {
        accessorKey: 'wellpoints_amount',
        header: B2BWellPointsPageData.tableHeaderText.wellPoints,
        cell: ({ row }) => (
          <div className="text-[15px] leading-[18px] font-normal text-black dark:text-white">
            {formatAmount(row.original.well_points)}
          </div>
        )
      },
      {
        accessorKey: 'status',
        header: B2BWellPointsPageData.tableHeaderText.status,
        cell: ({ row }) => {
          const status = row?.original?.status;

          let actionStyle;
          if (status === 1) {
            actionStyle = 'bg-[#DDF2BF] border-[#438038] text-[#438038]';
          } else if (status === 2) {
            actionStyle = 'bg-[#F9EBE9] border-[#991B1B] text-[#991B1B]';
          }

          return (
            <div
              className={`px-6 py-1 text-xs inline-block capitalize rounded-full border text-center ${actionStyle}`}
            >
              {getPaymentStatus(status)}
            </div>
          );
        }
      },
      {
        id: 'actions',
        header: B2BWellPointsPageData.tableHeaderText.action,
        enableHiding: false,
        cell: ({ row }) => {
          const rowId = row.original.id;

          return (
            <div className="max-w-[100px] relative">
              <CommonPopover
                label={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
                    />
                  </svg>
                }
                className="bg-transparent rounded-full p-1 border border-transparent"
                contentClassName="!p-1"
                anchor={{ to: 'bottom start', gap: '4px' }}
              >
                {row?.original?.status !== 2 && (
                  <ul className={`text-sm p-4 space-y-2`}>
                    <li>
                      <Link to={`/peap-B2B-wellPoints/view/${row?.original?._id}`}>
                        {B2BWellPointsPageData.tableHeaderText.viewInvoiceBtnText}
                      </Link>
                    </li>
                  </ul>
                )}
                {row?.original?.status === 2 && (
                  <ul className={`text-base p-4 space-y-2 border-t`}>
                    <li>
                      <Link to={`/peap-B2B-wellPoints/generate/invoice/` + rowId}>
                        {B2BWellPointsPageData.tableHeaderText.viewInvoiceBtnText}
                      </Link>
                    </li>
                  </ul>
                )}
              </CommonPopover>
            </div>
          );
        }
      }
    ],
    [editingRowId, editingAmount, wellpointTransactionList]
  );

  /* USE EFFECT */
  useEffect(() => {
    if (editingRowId && inputRef.current[editingRowId]) {
      inputRef.current[editingRowId].focus();
    }
  }, [editingRowId, editingAmount]);

  /* FETCH WITHDRAWAL DETAILS */
  const fetchAutoWithdrawDetails = async () => {
    try {
      setLoading(true);
      Api.getWellpointsCount().then((response) => {
        const responseData = response?.data || {};
        if (responseData?.meta?.code === 200) {
          const result = responseData?.data || {};
          setWellpointStatisticsData(result);
        }
      });
    } catch (error) {
      console.error('Error fetching get wellpoints count:', error);
    } finally {
      setLoading(false);
    }
  };

  /* USE EFFECT */
  useEffect(() => {
    fetchAutoWithdrawDetails();
  }, []);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (searchText) {
        handlePagination(currentPage, recordsPerPage, filterQuery);
      }
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [searchText]);
  return (
    <>
      <div className="relative">
        {(loader || loading) && <Loader />}

        {/* HELMET */}
        <Helmet>
          <meta charSet="utf-8" />
          <title>{B2BWellPointsPageData.metaTitle}</title>
        </Helmet>

        {/* TOPBAR */}
        {/* <Topbar
          title={B2BWellPointsPageData.pageTitle}
          hasDesc
          description={B2BWellPointsPageData.pageDescription}
        /> */}

        {/* FILTERS */}
        <div className="mt-10">
          <div className="flex items-center justify-between">
            <SearchInput
              className="inline-flex items-centerjustify-center px-5 py-6 border border-transparent rounded-full"
              id="searchKey"
              name="searchKey"
              type="text"
              placeholder={B2BWellPointsPageData.searchPlaceholder}
              inputClassName="rounded-full"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>
        </div>

        {/* STATISTICS CARD */}
        <div className="mt-5">
          <div className="grid grid-cols-4 gap-5">
            {/* SUBMITTED INVOICES */}
            <div className="col-span-1">
              <InvoiceStatCard
                icon={require('../../../assets/images/new-icons/submitted-invoices.png')}
                title={B2BWellPointsPageData.submittedInvoiceText}
                value={totalCount}
              />
            </div>

            {/* TOTAL AMOUNT PAID */}
            <div className="col-span-1">
              <InvoiceStatCard
                icon={require('../../../assets/images/new-icons/amount-paid.png')}
                title={B2BWellPointsPageData.totalAmountPaidText}
                value={`£${formatAmount(wellpointStatisticsData?.totalPurchasedWellPoints, true)}`}
              />
            </div>

            {/* TOTAL PAID INVOICES - NOT DYNAMIC */}
            <div className="col-span-1">
              <InvoiceStatCard
                icon={require('../../../assets/images/new-icons/paid-invoices.png')}
                title={B2BWellPointsPageData.totalPaidInvoicesText}
                value={paidInvoicesCount}
              />
            </div>

            {/* OVERDUE INVOICES - NOT DYNAMIC */}
            <div className="col-span-1">
              <InvoiceStatCard
                icon={require('../../../assets/images/new-icons/overdue-invoices.png')}
                title={B2BWellPointsPageData.overdueInvoicesText}
                value={unpaidInvoicesCount}
              />
            </div>
          </div>
        </div>

        {/* TABLE CARD */}
        <div className="mt-5">
          <div className="bg-white dark:bg-shoorah-darkBgTabColor border border-[#E7E8EA] dark:border-transparent rounded-lg">
            <div className="p-5">
              {/* TABS */}
              <div className="flex items-center gap-3">
                {/* ALL INVOICES */}
                <Button
                  onClick={() => setSelectedTab('All')}
                  className={`flex items-center gap-2 text-sm font-normal text-black dark:text-white border ${
                    selectedTab === 'All'
                      ? 'border-black dark:border-white'
                      : 'border-[#E7E8EA] dark:border-white/40'
                  } px-4 py-2 rounded-full`}
                >
                  {B2BWellPointsPageData.allInvoicesChipLabel}
                  <span className="px-3 py-1 text-xs font-medium bg-[#F1F1F1] rounded-full text-shoorah-primary">
                    {totalCount}
                  </span>
                </Button>

                {/* PAID INVOICES - NOT DYNAMIC */}
                <Button
                  onClick={() => setSelectedTab('Paid')}
                  className={`flex items-center gap-2 text-sm font-normal text-black dark:text-white border ${
                    selectedTab === 'Paid'
                      ? 'border-black dark:border-white'
                      : 'border-[#E7E8EA] dark:border-white/40'
                  } px-4 py-2 rounded-full`}
                >
                  {B2BWellPointsPageData.paidChipLabel}
                  <span className="px-3 py-1 text-xs font-medium bg-[#DDF2BF] rounded-full text-[#438038]">
                    {paidInvoicesCount}
                  </span>
                </Button>

                {/* PENDING INVOICES - NOT DYNAMIC */}
                <Button
                  onClick={() => setSelectedTab('Pending')}
                  className={`flex items-center gap-2 text-sm font-normal text-black dark:text-white border ${
                    selectedTab === 'Pending'
                      ? 'border-black dark:border-white'
                      : 'border-[#E7E8EA] dark:border-white/40'
                  } px-4 py-2 rounded-full`}
                >
                  {B2BWellPointsPageData.pendingChipLabel}
                  <span className="px-3 py-1 text-xs font-medium bg-[#FFFDD2] rounded-full text-[#CCB014]">
                    {unpaidInvoicesCount}
                  </span>
                </Button>
              </div>

              {/* TABLE */}
              <div className="mt-5">
                <CommonTable data={wellpointTransactionList || []} columns={columns} />
                <div>
                  {totalCount > recordsPerPage ? (
                    <Pagination
                      currentPage={currentPage}
                      totalCount={totalCount}
                      pageSize={recordsPerPage}
                      onPageChange={(page) => handlePagination(page, recordsPerPage, filterQuery)}
                    />
                  ) : (
                    <span />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* APPROVAL PAYMENT POPUP */}
        <ApprovePaymentPopup
          open={openPaymentApproveModal}
          onClose={() => setOpenPaymentApproveModal(false)}
          onSubmit={handlePaymentApprove}
          isLoadingUpdate={isLoadingUpdate}
        />
      </div>
    </>
  );
};

export default B2BWellPoints;
